import { render, staticRenderFns } from "./KycProviderPage.vue?vue&type=template&id=0f867ff9&"
import script from "./KycProviderPage.vue?vue&type=script&lang=js&"
export * from "./KycProviderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports